import { render, staticRenderFns } from "./AllowedDatePicker.vue?vue&type=template&id=febb354e&"
import script from "./AllowedDatePicker.vue?vue&type=script&lang=js&"
export * from "./AllowedDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports